import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIFriendService, TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../../adapter-vue";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import TUICore from "@tencentcloud/tui-core";
import SelectUser from "../../common/SelectUser/index.vue";
import Server from "../server";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var TUIContactServer = Server.getInstance();
    var TUIConstants = TUIContactServer.constants;
    var needSearch = ref(false);
    var friendList = ref([]);
    var userList = ref([]);
    var TUISearchServer = ref(null);
    var selectOptions = ref({
      isRadio: false,
      isNeedSearch: false,
      title: ''
    });
    var generateSearchServer = function generateSearchServer(isNeedSearch) {
      TUISearchServer.value = TUICore.getService(TUIConstants.TUISearch.SERVICE.NAME);
      if (TUISearchServer.value) {
        needSearch.value = isNeedSearch;
      } else {
        console.warn('请添加 TUISearch 组件');
      }
    };
    watchEffect(function () {
      var params = TUIContactServer.getOnCallParams(TUIConstants.TUIContact.SERVICE.METHOD.SELECT_FRIEND);
      selectOptions.value.title = params.title;
      selectOptions.value.isRadio = params.isRadio;
      selectOptions.value.isNeedSearch = params.isNeedSearch;
      if (params.isNeedSearch) {
        generateSearchServer(params.isNeedSearch);
      }
      TUIFriendService.getFriendList().then(function (res) {
        friendList.value = res.data.map(function (item) {
          return item.profile;
        });
        userList.value = friendList.value;
      })["catch"](function (err) {
        console.warn("getFriendList error:", err);
      });
    });
    var handleSelectedResult = function handleSelectedResult(memberList) {
      TUIStore.update(StoreName.CUSTOM, "isShowSelectFriendComponent", false);
      var callback = TUIContactServer.getOnCallCallback(TUIConstants.TUIContact.SERVICE.METHOD.SELECT_FRIEND);
      callback && callback(memberList);
    };
    var searchFail = function searchFail() {
      Toast({
        message: TUITranslateService.t("TUIGroup.该用户不存在"),
        type: TOAST_TYPE.ERROR
      });
      userList.value = _toConsumableArray(friendList.value);
    };
    var handleSearch = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var imResponse, searchAllResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (val) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", userList.value = friendList.value);
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return TUISearchServer.value.searchUser(val);
            case 5:
              imResponse = _context.sent;
              if (imResponse.data[0]) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", searchFail());
            case 8:
              userList.value = imResponse.data;
              searchAllResult = friendList.value.filter(function (item) {
                return item.userID === imResponse.data[0].userID;
              });
              friendList.value = searchAllResult.length ? friendList.value : [].concat(_toConsumableArray(friendList.value), _toConsumableArray(userList.value));
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              return _context.abrupt("return", searchFail());
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 13]]);
      }));
      return function handleSearch(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(SelectUser, {
        isRadio: _unref(selectOptions).isRadio,
        isNeedSearch: _unref(selectOptions).isNeedSearch,
        title: _unref(selectOptions).title,
        userList: _unref(userList),
        onSearch: handleSearch,
        onComplete: handleSelectedResult
      }, null, 8, ["isRadio", "isNeedSearch", "title", "userList"]);
    };
  }
});